import { app, db } from "@/firebase/init.js";
import {
  getDatabase,
  query,
  ref,
  onValue,
  orderByChild,
  limitToLast,
} from "firebase/database";
import { doc, getDoc } from "firebase/firestore"; //

function snapshotToArray(snapshot) {
  var returnArr = [];

  snapshot.forEach(function (childSnapshot) {
    var item = childSnapshot.val();
    item.key = childSnapshot.key;

    returnArr.push(item);
  });

  return returnArr;
}

const database = getDatabase(app);
const analyticsModule = {
  namespaced: true,
  state: {
    analyticsList: {},
    top_payments: [],
    top_viewes: [],
    recently_added: [],
    isFirstLoad: true,
  },
  getters: {
    isFirstLoad: (state) => state.isFirstLoad,
    // Pages Count
    getCodesCount: (state) => state.analyticsList.codes,
    getUsersCount: (state) => state.analyticsList.users,
    getStudentsCount: (state) => state.analyticsList.students,
    getExamResultsCount: (state) => state.analyticsList.examResults,
    // Analytics
    getAnalytics: (state) => state.analyticsList,
    getTopPayments: (state) => state.top_payments,
    getTopViews: (state) => state.top_viewes,
    getRecentlyAdded: (state) => state.recently_added,
  },
  mutations: {
    // First load
    setFirstLoad: (state, payload) => {
      state.isFirstLoad = payload;
    },

    setAnalytics: (state, payload) => {
      state.analyticsList = payload;
    },
    setTopPayments: (state, payload) => {
      state.top_payments = payload;
    },
    setTopViews: (state, payload) => {
      state.top_viewes = payload;
    },
    setRecentlyAdded: (state, payload) => {
      state.recently_added = payload;
    },
  },
  actions: {
    async fetchAnalytics({ commit }) {
      commit("setFirstLoad", true);

      const starCountRef = ref(database, "analytics");
      onValue(starCountRef, (snapshot) => {
        const data = snapshot.val();
        commit("setAnalytics", data);
      });
      commit("setFirstLoad", false);
    },

    async fetchTopPayments({ commit }) {
      commit("setFirstLoad", true);

      const starCountRef = query(
        ref(database, "contents"),
        orderByChild("payments"),
        limitToLast(5)
      );
      onValue(starCountRef, (snapshot) => {
        let data = snapshotToArray(snapshot);

        data.sort((a, b) => (a.payments < b.payments ? -1 : 1));

        const dataPromises = data.map(async (item) => {
          let file = await getDoc(doc(db, item.type, item.content_id));
          return file.data() || [];
        });
        // 4H2twh2VfoBTIlX6HjrM
        Promise.all(dataPromises).then((file) => {
          let data = file.filter((e) => e != null);
          commit("setTopPayments", data);
          commit("setFirstLoad", false);
        });
      });
    },

    async fetchTopViews({ commit }) {
      commit("setFirstLoad", true);

      const starCountRef = query(
        ref(database, "contents"),
        orderByChild("views"),
        limitToLast(5)
      );
      onValue(starCountRef, (snapshot) => {
        let data = snapshotToArray(snapshot);
        data.sort((a, b) => b.views - a.views);
        const dataPromises = data.map(async (item) => {
          let file = await getDoc(doc(db, item.type, item.content_id));
          return file.data()||[];
        });
        Promise.all(dataPromises).then((file) => {
          let data = file.filter((e) => e != null);
          commit("setTopViews", data);
          commit("setFirstLoad", false);
        });
      });
    },

    async fetchRecentlyAdded({ commit }) {
      commit("setFirstLoad", true);

      const starCountRef = query(
        ref(database, "contents"),
        orderByChild("created_date"),
        limitToLast(5)
      );
      onValue(starCountRef, (snapshot) => {
        let data = snapshotToArray(snapshot);
        data.sort((a, b) => b.created_date.seconds - a.created_date.seconds);

        const dataPromises = data.map(async (item) => {
          let file = await getDoc(doc(db, item.type, item.content_id));
          return file.data() || [];
        });
        Promise.all(dataPromises).then((file) => {
          let data = file.filter((e) => e != null);
          commit("setRecentlyAdded", data);
          commit("setFirstLoad", false);
        });
      });
    },
  },
};

export default analyticsModule;
